(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-need"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll( '.faq-title').forEach ( (a) =>{
  a.addEventListener('click', function() {
    var questionDiv = $('.faq-title');
    var answerDiv = $('.faq-content');
    if ($(this).next().hasClass('openFAQ')) {
      $(this).removeClass('active');
      $(this).next().removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
    } else if ($(answerDiv).hasClass('openFAQ')) {
      $(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
      $(questionDiv).removeClass('active');
      $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
      $(this).addClass('active');
    } else {
      $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
      $(this).addClass('active');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
function videoPopupWhenReady() {
  $('.article-template__content .popup-video').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-popup-video'
  });
}
window.addEventListener('DOMContentLoaded', (event) => {
  videoPopupWhenReady();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-backup-uso"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }


              this.classList.add('product-recommendations--loaded');

          })
          .catch(e => {
            console.error(e);
          });

      }


      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);

    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-swatch-variant-type"] && !window.DesignMode) return;
  try {
    
class SwatchTypeColor extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".product-swatch-large-small img").forEach((swatch) => swatch.addEventListener("click", this.changeContent.bind(this)));
  }

  changeContent(e) {
    this.data = e.target;
    this.querySelectorAll(".product-swatch-large-small img").forEach((swatch) => swatch.classList.remove("active"));
    e.target.classList.add("active")
    this.querySelector(".product-swatch-large-image img").src = this.data.getAttribute("data-image");
    this.querySelector(".heading-type strong").innerHTML = this.data.getAttribute("data-title");
    this.querySelector(".button-product a.button").href = this.data.getAttribute("data-url");
  }
}

window.customElements.define('swatchtype-section', SwatchTypeColor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-reviews"] && !window.DesignMode) return;
  try {
    
function sliderReviewsWhenReady() {
  if (typeof $.fn.slick != 'undefined') {
    $('.slider-reviews').not(".slick-initialized").slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: '.nav-reviews .slick-next',
          prevArrow: '.nav-reviews .slick-prev'
        });
  }
  else {
      setTimeout(fireWhenReady, 600);
  }
}
window.addEventListener('DOMContentLoaded', (event) => {
  sliderReviewsWhenReady();
});

  } catch(e) { console.error(e); }
})();
})();
